import type { SVGProps } from "react";

export default function ArrowRightIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.99902 11.9995H19.999M13.999 17.9995L19.999 11.9995L13.999 5.99951"
        stroke="currentColor"
        strokeWidth="1.50634"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
